{
  "familyId": "GET-KOMMA-AFRONDEN",
  "questions": [
    {
      "id": "GET-KOMMA-AFRONDEN-001",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 3,47 af op één decimaal.",
      "options": ["3,5", "3,4", "3,0", "4,0"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 3.4,
            "end": 3.5,
            "marked": [3.47],
            "step": 0.1,
            "label": "3,47 op de getallenlijn tussen 3,4 en 3,5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op 1 decimaal",
            "content": "Kijk naar het honderdstencijfer (het tweede cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 3.4,
            "end": 3.5,
            "marked": [3.47],
            "highlight": [3.5],
            "arrows": [{"from": 3.47, "to": 3.5, "label": "dichter bij 3,5"}],
            "step": 0.1,
            "label": "3,47 ligt dichter bij 3,5 dan bij 3,4"
          }
        }
      ],
      "conceptId": "komma_afronden_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 3,47: dat is de 7. Is 7 gelijk aan of groter dan 5? Ja — dus je rondt omhoog af. 3,47 wordt 3,5. Controleer: 3,47 ligt dichter bij 3,5 dan bij 3,4.",
        "solutionSteps": [
          "Kijk naar het honderdstencijfer: de 7 in 3,47",
          "Is 7 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 3,47 → 3,5",
          "Check: 3,47 ligt dichter bij 3,5 dan bij 3,4 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Het honderdstencijfer is 7 (≥ 5), dus 3,47 wordt 3,5.",
          "1": "Je dacht waarschijnlijk dat je altijd naar beneden afrondt. Maar het honderdstencijfer is 7, en 7 is groter dan 5. Onthoud: 5 of meer = omhoog afronden. Dus 3,47 → 3,5, niet 3,4.",
          "2": "Je dacht waarschijnlijk dat je op een heel getal moest afronden. Maar de vraag vraagt op één decimaal. Op 1 decimaal: 3,5. Op een heel getal zou het 3 zijn. Onthoud: lees goed hoeveel decimalen gevraagd worden.",
          "3": "Je dacht waarschijnlijk dat het honderdstencijfer (7) bij de eenheden hoort. Maar 3,47 afgerond op 1 decimaal is 3,5, niet 4,0. Onthoud: je rondt af op de tiendenplek, niet op de eenhedenplek."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-002",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 12,345 af op twee decimalen.",
      "options": ["12,35", "12,34", "12,3", "12,40"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 12.34,
            "end": 12.35,
            "marked": [12.345],
            "step": 0.01,
            "label": "12,345 precies in het midden tussen 12,34 en 12,35"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op 2 decimalen",
            "content": "Kijk naar het duizendstencijfer (het derde cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog. Is het lager dan 5? Rond dan omlaag.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_afronden_honderdsten",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 12,345: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus je rondt omhoog af. 12,345 wordt 12,35. Controleer: 12,35 × 1 = 12,35 ✓.",
        "solutionSteps": [
          "Kijk naar het duizendstencijfer: de 5 in 12,345",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 12,345 → 12,35"
        ],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 5 (≥ 5), dus 12,345 wordt 12,35.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar de afspraak is: 5 of meer → altijd omhoog. Dus 12,35, niet 12,34. Onthoud: bij twijfel, bij 5 ga je omhoog.",
          "2": "Je dacht waarschijnlijk dat je op 1 decimaal moest afronden. Maar de vraag vraagt op 2 decimalen. Op 2 decimalen: 12,35. Op 1 decimaal zou het 12,3 zijn. Onthoud: tel het aantal gevraagde decimalen.",
          "3": "Je dacht waarschijnlijk dat je een nul moest toevoegen. Maar 12,35 is het antwoord — de extra nul in 12,40 verandert de waarde niet en is niet nodig. Onthoud: schrijf geen onnodige nullen achter het laatste cijfer."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-003",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 9,95 af op één decimaal.",
      "options": ["10,0", "9,9", "10", "9,10"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 9.9,
            "end": 10.0,
            "marked": [9.95],
            "step": 0.1,
            "label": "9,95 precies in het midden tussen 9,9 en 10,0"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Doorrol bij afronden",
            "content": "Soms loopt het afronden door naar de volgende positie. Als 9,9 omhoog gaat, wordt het 10,0. De 9 op de tiendenplek loopt door naar de eenheden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_afronden_doorrol",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Kijk naar het honderdstencijfer in 9,95: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus omhoog. 9,9 + 0,1 = 10,0. Let op: de 9 op de tiendenplek loopt door naar de eenheden! Controleer: 10,0 afgerond op 1 decimaal klopt — de decimaal staat er nog bij.",
        "solutionSteps": [
          "Kijk naar het honderdstencijfer: de 5 in 9,95",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 9,9 + 0,1 = 10,0",
          "Let op: de 9 loopt door naar de eenheden!",
          "Check: schrijf 10,0 (met decimaal) omdat gevraagd is op 1 decimaal ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 9,95 afgerond op 1 decimaal = 10,0. De 5 zorgt voor omhoog, en 9,9 + 0,1 = 10,0.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar het honderdstencijfer is 5, en 5 of meer = altijd omhoog. Dus 10,0, niet 9,9. Onthoud: bij 5 ga je omhoog.",
          "2": "Je dacht waarschijnlijk dat 10 en 10,0 hetzelfde zijn. Wiskundig klopt dat, maar bij afronden op 1 decimaal schrijf je 10,0 — zo laat je zien dat je op de tiendenplek hebt afgerond. Onthoud: schrijf het gevraagde aantal decimalen.",
          "3": "Je dacht waarschijnlijk dat je de 9 als 10 schrijft maar de tienden behoudt. Maar 9,95 → 10,0, niet 9,10. De hele 9,9 loopt door naar 10,0. Onthoud: als de tiendenplek doorloopt, verandert ook het getal vóór de komma."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-004",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Een product kost €7,849. Rond af op centen (twee decimalen).",
      "options": ["€7,85", "€7,84", "€7,90", "€8,00"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 7.84,
            "end": 7.85,
            "marked": [7.849],
            "step": 0.01,
            "label": "€7,849 op de getallenlijn tussen €7,84 en €7,85"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op centen = afronden op 2 decimalen",
            "content": "Centen zijn honderdsten van een euro. Kijk naar het duizendstencijfer (het derde cijfer achter de komma). Is het 5 of hoger? Rond dan omhoog.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_afronden_context_geld",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 7,849: dat is de 9. Is 9 gelijk aan of groter dan 5? Ja — dus omhoog. €7,84 wordt €7,85. Controleer: €7,85 heeft twee decimalen (centen) ✓.",
        "solutionSteps": [
          "Kijk naar het duizendstencijfer: de 9 in 7,849",
          "Is 9 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: €7,849 → €7,85",
          "Check: twee decimalen = centen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 9 (≥ 5), dus €7,849 ≈ €7,85.",
          "1": "Je dacht waarschijnlijk dat je naar beneden afrondt. Maar het duizendstencijfer is 9, en 9 is groter dan 5. Onthoud: 5 of meer = omhoog afronden. Dus €7,85, niet €7,84.",
          "2": "Je dacht waarschijnlijk dat je op 1 decimaal moest afronden. Maar centen zijn 2 decimalen. Op 2 decimalen: €7,85. Op 1 decimaal zou het €7,8 zijn (niet €7,90). Onthoud: centen = het tweede cijfer achter de komma.",
          "3": "Je dacht waarschijnlijk dat je op hele euro's moest afronden. Maar de vraag vraagt op centen (2 decimalen). Op centen: €7,85. Op hele euro's zou het €8,00 zijn. Onthoud: lees goed hoeveel decimalen gevraagd worden."
        }
      }
    },
    {
      "id": "GET-KOMMA-AFRONDEN-005",
      "familyId": "GET-KOMMA-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_afronden",
      "questionType": "multiple_choice",
      "question": "Rond 0,0451 af op twee decimalen.",
      "options": ["0,05", "0,04", "0,045", "0,00"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0.04,
            "end": 0.05,
            "marked": [0.0451],
            "step": 0.01,
            "label": "0,0451 op de getallenlijn tussen 0,04 en 0,05"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op 2 decimalen bij kleine getallen",
            "content": "Kijk naar het duizendstencijfer (het derde cijfer achter de komma). In 0,0451 is dat de 5. Is het 5 of hoger? Rond dan omhoog: 0,04 wordt 0,05.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_afronden_klein_getal",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Kijk naar het duizendstencijfer in 0,0451: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus omhoog. 0,04 wordt 0,05. Controleer: 0,05 heeft twee decimalen ✓.",
        "solutionSteps": [
          "Kijk naar het duizendstencijfer: de 5 in 0,0451",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 0,0451 → 0,05",
          "Check: 0,05 heeft twee decimalen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Het duizendstencijfer is 5 (≥ 5), dus 0,0451 ≈ 0,05.",
          "1": "Je dacht waarschijnlijk dat je bij een 5 naar beneden afrondt. Maar de afspraak is: 5 of meer → altijd omhoog. Dus 0,05, niet 0,04. Onthoud: bij twijfel, bij 5 ga je omhoog.",
          "2": "Je dacht waarschijnlijk dat je op 3 decimalen moest afronden. Maar de vraag vraagt op 2 decimalen. Op 2 decimalen: 0,05. Op 3 decimalen zou het 0,045 zijn. Onthoud: tel het aantal gevraagde decimalen.",
          "3": "Je dacht waarschijnlijk dat 0,0451 zo klein is dat het nul wordt. Maar 0,0451 is klein maar niet nul. Afgerond op 2 decimalen: 0,05. Onthoud: kijk altijd naar het derde cijfer achter de komma, ook bij kleine getallen."
        }
      }
    }
  ]
}